import { useState, useRef } from "react";
import axios from "axios";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import LoadingSpinner from "../../../components/LoadingSpinner";

export default function UploadImageModal({ id, cancelModal, fetchData }) {
  const [selectedFile, setSelectedFile] = useState(null);
  const { user } = useAuthContext();
  const [previewUrl, setPreviewUrl] = useState(null);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadError, setUploadError] = useState("");

  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    try {
      const file = e.target.files[0];
      setSelectedFile(file);
      setUploadError("");
      if (file) {
        setPreviewUrl(URL.createObjectURL(file));
      } else {
        setPreviewUrl(null);
      }
    } catch (error) {
      console.error("Error handling file change:", error);
    }
  };

  const fileUploadHandler = async (e) => {
    e.preventDefault();
    if (!selectedFile) return;

    setIsLoading(true);

    const formData = new FormData();
    formData.append("image", selectedFile);

    try {
      const response = await axios.post(
        `${ApiConnectionString}/api/PendingImage`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status === 200) {
        fetchData();
        setUploadSuccess(true);
      }
    } catch (error) {
      if (error.response?.status === 400) {
        console.error("400 Error:", error.response.data);
        setUploadError(error.response.data);
      } else {
        console.error("Error uploading image:", error);
      }
    } finally {
      setIsLoading(false);
      setSelectedFile(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
    }
  };

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
        </div>
      </div>
    );
  }

  if (uploadSuccess) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <div className="blueBanner">
            <p className="fw-bold m-2 p-2 fontSize20">Image Uploaded</p>
          </div>

          <p>Would you like to add another image?</p>
          <button
            type="button"
            className="close-button"
            onClick={cancelModal}
            aria-label="Close"
          >
            &times;
          </button>
          <div className="send-modal-footer">
            <button
              className="saveChanges-button mx-3"
              onClick={() => {
                setUploadSuccess(false);
                setPreviewUrl(null);
                setSelectedFile(null);
                if (fileInputRef.current) {
                  fileInputRef.current.value = null;
                }
              }}
            >
              Yes
            </button>
            <button
              onClick={cancelModal}
              className="pointer cancelButton fw-bold mx-2 px-3"
            >
              No
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="send-modal-overlay">
      <div className="send-modal">
        <div>
          <div className="send-modal-content">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">Upload Club Image</p>
            </div>
            <button
              type="button"
              className="close-button"
              onClick={cancelModal}
              aria-label="Close"
            >
              &times;
            </button>
            <div>
              <input
                type="file"
                onChange={handleFileChange}
                ref={fileInputRef}
              />
              <button
                className="saveChanges-button"
                onClick={fileUploadHandler}
              >
                Upload
              </button>
            </div>

            {uploadError && (
              <p className="text-danger mt-2">{uploadError}</p>
            )}

            {previewUrl && (
              <img
                src={previewUrl}
                alt="Image Preview"
                style={{ width: "100px", height: "100px" }}
              />
            )}
          </div>
          <div className="send-modal-footer">
            <button
              onClick={cancelModal}
              className="pointer cancelButton fw-bold mx-2 px-3"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
